import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { OrderStatus } from "./useOrderInfo";

const ShippingStatusTagWrapper = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div data-testid="shipping-status-tag" className={clsx("vst-tag", className)}>
    {children}
  </div>
);

export default function ShippingStatusTag({
  orderStatus,
}: {
  orderStatus?: OrderStatus;
}) {
  if (orderStatus === "Picked Up") {
    return (
      <ShippingStatusTagWrapper className="vst-tag-variant-green">
        <FormattedMessage defaultMessage="Picked up" />
      </ShippingStatusTagWrapper>
    );
  } else if (orderStatus === "Ready for Pickup") {
    return (
      <ShippingStatusTagWrapper className="vst-tag-variant-green">
        <FormattedMessage defaultMessage="Ready for Campus Pickup" />
      </ShippingStatusTagWrapper>
    );
  } else if (orderStatus === "Preparing to Ship") {
    return (
      <ShippingStatusTagWrapper className="vst-tag-variant-frost">
        <FormattedMessage defaultMessage="Preparing for Shipment" />
      </ShippingStatusTagWrapper>
    );
  } else if (orderStatus === "Shipped") {
    return (
      <ShippingStatusTagWrapper className="vst-tag-variant-frost">
        <FormattedMessage defaultMessage="Shipped" />
      </ShippingStatusTagWrapper>
    );
  } else {
    return null;
  }
}
